import QuestionnaireListingContainer from "./QuestionnaireListingContainer";

export default QuestionnaireListingContainer;
